import React from "react";
import { Stack } from "@datanomik/commons-ui";
import { CashPoolingExceedIcon, CashPoolingMinimumIcon, CashPoolingFixedIcon } from "../../shared/CashPoolingRuleTypesIcons";
import { CASH_POOLING_LABELS } from "../../shared/cash-pooling.labels";
import { RuleCreationTypeCard } from "./RuleCreationTypeCard";

interface RuleCreationTypeSelectorProps {
  onSelectExcessRule: () => void;
  onSelectMinimumRule: () => void;
  onSelectRecurrenceRule: () => void;
}

export const RuleCreationTypeSelector: React.FC<
  RuleCreationTypeSelectorProps
> = ({ onSelectExcessRule, onSelectMinimumRule, onSelectRecurrenceRule }) => {
  const ruleTypes = [
    {
      name: CASH_POOLING_LABELS.EXCESS.NAME,
      description: CASH_POOLING_LABELS.EXCESS.DESCRIPTION,
      icon: <CashPoolingExceedIcon />,
      onClick: onSelectExcessRule,
    },
    {
      name: CASH_POOLING_LABELS.MINIMUM.NAME,
      description: CASH_POOLING_LABELS.MINIMUM.DESCRIPTION,
      icon: <CashPoolingMinimumIcon />,
      onClick: onSelectMinimumRule,
    },
    {
      name: CASH_POOLING_LABELS.FIXED.NAME,
      description: CASH_POOLING_LABELS.FIXED.DESCRIPTION,
      icon: <CashPoolingFixedIcon />,
      onClick: onSelectRecurrenceRule,
    },
  ];

  return (
    <Stack spacing="16px">
      {ruleTypes.map((ruleType) => (
        <RuleCreationTypeCard
          key={ruleType.name}
          name={ruleType.name}
          description={ruleType.description}
          icon={ruleType.icon}
          onClick={ruleType.onClick}
        />
      ))}
    </Stack>
  );
};
